import { useEffect, useState } from "react";
import { Grid, styled } from "@mui/material";
import { TransactionErrorModel, UpdateTransactionErrorCategoryInput } from "../../gql-types.generated";
import AddEditDialog from "./AddEditDialog";
import ErrorCategoryField from "../fields/ErrorCategoryField";

export const GridContainer = styled(Grid)((props) => ({
    width: '440px', 
}));

interface ErrorLogDialogProps {
    isOpen: boolean;
    errorLogInfo?: TransactionErrorModel;
    onClose: () => void;
    onSave: (
        categoryInput: UpdateTransactionErrorCategoryInput
    ) => void;
    error?: Error | undefined;
}

const EditErrorLogDialog: React.FC<ErrorLogDialogProps> = props => {
    const { isOpen, errorLogInfo, onClose, onSave, error } = props;
    const [isDirty, setIsDirty] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [errorLogId, setErrorLogId] = useState<string>('');
    
    // Form Fields
    const [errorLogCategoryId, setErrorLogCategoryId] = useState<string | undefined>(undefined);
   
    useEffect(() => {
        if (errorLogInfo) {
            setFromErrorLogInfo();
        } else {
            setToDefaults();
        }
    }, [errorLogInfo]);

    const setFromErrorLogInfo = () => {
        if (errorLogInfo) {
            if (errorLogInfo.id) {
                setErrorLogId(errorLogInfo.id);
            }

            if (errorLogInfo.category && errorLogInfo.category.id) {
                setErrorLogCategoryId(errorLogInfo.category.id);
            }
        }
    };

    useEffect(() => {
        if (!isOpen) {
            setToDefaults();
            setSubmitted(false);
            setIsDirty(false);
        } else {
            setFromErrorLogInfo();
        }
    }, [isOpen]);

    const setToDefaults = () => {
        setErrorLogId('');
        setErrorLogCategoryId(undefined);
    };
    
    const saveLogCategory = () => {
        if (isFormValid()) {
            setSubmitted(true);
            onSave({transactionErrorId: errorLogId, categoryId: errorLogCategoryId});
        }
    };

    const onError = () => {
        setSubmitted(false);
    };

    const isFormValid = () => {
        return isDirty && errorLogId?.length > 0;
    };
    
    const onCategoryChange = (categoryId?: string) => {
        setIsDirty(true);
        setErrorLogCategoryId(categoryId);
    };

    return (
        <AddEditDialog
            isOpen={isOpen}
            isSubmitted={submitted}
            entityName="Error Category"
            id={errorLogId}
            onCancel={onClose}
            onClose={onClose}
            onSave={saveLogCategory}
            validate={isFormValid}
            onError={onError}
            error={error}
            maxWidth='md'
        >
            <GridContainer container spacing={2}>
                <Grid item xs={12}>
                    <ErrorCategoryField
                        value={errorLogCategoryId}
                        onChange={onCategoryChange}
                        disabled={submitted}
                    />
                </Grid>
            </GridContainer>
        </AddEditDialog>
    );
}

export default EditErrorLogDialog;